var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 50 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171275478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 269",
    d: "M17 5V5C18.6569 6.65685 21.3431 6.65685 23 5V5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 270",
    d: "M28 5V5C29.6569 6.65685 32.3431 6.65685 34 5V5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 268",
    d: "M29.6001 14.1342L31.5 10L33.3999 14.1342C33.7614 14.9208 33.6008 15.8488 32.9959 16.4682C32.1756 17.3082 30.8244 17.3082 30.0041 16.4682C29.3992 15.8488 29.2386 14.9208 29.6001 14.1342Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage34);
export default __webpack_public_path__ + "static/media/page3_4.18af37dbeaefd03d826e27be8c3fea44.svg";
export { ForwardRef as ReactComponent };